export default function updatePersonalInformation() {
// Revision History
// 2024-10-18 TBH - Added conditional update of SSN and birth date.
// 2024-10-29 TBH - Rewrote so form element in UpdatePersonalInformation\Default.cshtml submits on Save.
// console.log( 'updatePersonalInformation()' );
  return {
    genderList:[],            // Gender options fetched from server-side.
    gender: '',               // x-model for gender input.
    isGender:true,            // gender selection is valid.

    ethnicitiesList:[],       // Ethnicity options fetched from server-side.
    ethnicity: '',            // x-model for ethinicity input.
    isEthnicity: true,        // ethinicity selection is valid.

    socialSecurityNumber: '', // SSN input validation done by inputmode and mask. Server side with verify unique SSN.

    minBirthDate: '',         // Minimum birth date (CommonService.MinBirthDate).
    birthDate: '',            // First from PEOPLE.BIRTH_DATE then x-model birthDate.
    isBirthDate:true,         // birth date greater than minBirthDate.

    fetchGenders() {
// console.log( 'fetchGenders()' )
      fetch( '/api/common/gender-identities')
      .then(( response ) => {
        if( response.ok ) {
          return( response.json())
        }
      }).then(( json ) => {
        this.genderList = json
      }).catch((error) => {
        console.error( 'fetchGenders() error: "' + error + '"' );
      });
    },
    fetchEthnicities() {
// console.log( 'fetchEthnicities()' )
      fetch(' /api/common/ethnicities')
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
      }).then((json) => {
        this.ethnicitiesList = json;
      }).catch((error) => {
        console.error( 'fetchEthnicities() error: "' + error + '"' );
      });
    },

    validateForm() {
// console.log( 'validateForm()' );
      // Don't use:
      //    let validForm = ( this.validateGender() && this.validateEthnicity())
      // Because later validation checks will be skipped if any before fail. Also easier to add/remove validation.
      let validForm = true;
      validForm &= this.validateGender();
      validForm &= this.validateEthnicity();
      // Birth date is validated on its own since unset DOB (1/1/1900) just is a warning and can be submitted.
      this.successMessage = ( validForm ) ? "" : "Please correct errors noted above."; 
    },
    validateGender() {
// console.log( 'validateGender()' );
      this.gender = $('#gender').val();
// console.log( 'gender: "' + this.gender + '"' );
      this.isGender = ( this.gender != "" );
// console.log( 'isGender: "' + this.isGender + '"' );
      return( this.isGender );
    },
    validateEthnicity() {
// console.log( 'validateEthnicity()' );
      this.ethnicity = $('#ethnicity').val();
// console.log( 'ethnicity: "' + this.ethnicity + '"' );
      this.isEthnicity = ( this.ethnicity != "" );
// console.log( 'isEtnicity: "' + this.isEthnicity + '"' );
      return( this.isEthnicity );
    },
    validateBirthDate() {
    // Use input type="date" min and max attributes validate entered birth date is in allowed
    // range [ 01/01/1900, current date - 7 years ]. This validation is just used to display
    // or clear warning that birth date required to reset password.
// console.log( 'validateBirthDate()' );
    if( $( '#birthDate' ).length == 0 ) {
    // If input doesn't exist then already have valid birth date. Nothing to check.
// console.log( 'R/O birth date.' );
      return( true );
    }
    this.birthDate = $('#birthDate').val()
// console.log( 'birthDate: "' + this.birthDate + '"' );
// console.log( 'minBirthDate: "' + this.minBirthDate + '"' );
      this.isBirthDate = ( this.birthDate > this.minBirthDate );
// console.log( 'isBirthDate: "' + this.isBirthDate + '"' );
      return( this.isBirthDate );
    },

    init() {
// console.log( 'init()' );
      this.fetchGenders();
      this.fetchEthnicities();

      this.birthDate = $('#hdnBirthDate').val();
// console.log( 'birthDate: "' + this.birthDate + '"' );
      this.minBirthDate = $('#hdnMinBirthDate').val();
// console.log( 'minBirthDate: "' + this.minBirthDate + '"' );

      this.validateBirthDate();
    }
  }
}